import { routes as rabbitRoutes } from 'constants/routes';

import { DEER_PREFIX } from './routes';

export const staticRoutesWithCustomSidebar = {
  reviewsFormFilling: `${DEER_PREFIX}${rabbitRoutes.performanceReview.forms}`,
  reviewsResultPage: `${DEER_PREFIX}${rabbitRoutes.performanceReview.result}`,
  reviewsResultChartOnlyPage: `${DEER_PREFIX}${rabbitRoutes.performanceReview.resultChartOnly}`,
  reviewCycleCreation: `${DEER_PREFIX}${rabbitRoutes.settings.review.reviewCycle}`,
  reviewCycleTemplateCreation: `${DEER_PREFIX}${rabbitRoutes.template.review.index}`,
  reviewCycleTemplatePreview: `${DEER_PREFIX}${rabbitRoutes.template.review.preview}`,
  engagementSurveyCreation: `${DEER_PREFIX}${rabbitRoutes.settings.engagement.pulseKickstart}`,
  engagementTemplateCreation: `${DEER_PREFIX}${rabbitRoutes.template.engagement.index}`,
  engagementTemplatePreview: `${DEER_PREFIX}${rabbitRoutes.template.engagement.preview}`,
};
